import script from "./ShoppingCart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShoppingCart.vue?vue&type=script&setup=true&lang=ts"

import "./ShoppingCart.vue?vue&type=style&index=0&id=0b1e1344&lang=css"

const __exports__ = script;

export default __exports__